import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00c3a2de"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "phone-bar"
};
const _hoisted_2 = {
  class: "peerStatus"
};
const _hoisted_3 = {
  id: "phoneAgentStatus"
};
const _hoisted_4 = {
  class: "softphone_timer"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkHTSCIT_lianjieduankai"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_createTextVNode("断开");
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkHTSCIT_lianjie"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_createTextVNode("重连");
const _hoisted_9 = {
  class: "callStatus"
};
const _hoisted_10 = {
  class: "callBtnList"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkhujiaozhongxin1"
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_createTextVNode("外呼");
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkguaji"
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_createTextVNode("挂机");
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkbaochi"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_createTextVNode("保持");
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkquxiaobaochi"
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取消保持");
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkjingyin"
}, null, -1));
const _hoisted_20 = /*#__PURE__*/_createTextVNode("静音");
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkjingyin"
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_createTextVNode("取消静音");
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkhujiaozhongxin1"
}, null, -1));
const _hoisted_24 = /*#__PURE__*/_createTextVNode("接听");
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkhujiaozhongxin1"
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_createTextVNode("获取空闲座席");
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-sdkhujiaozhongxin1"
}, null, -1));
const _hoisted_28 = /*#__PURE__*/_createTextVNode("座席登出");
const _hoisted_29 = {
  class: "dtmf"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dtmf-tit"
}, "webrtc拨号盘", -1));
const _hoisted_31 = {
  class: "dtmf-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_phoneBarTime = _resolveComponent("phoneBarTime");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_select, {
    modelValue: _ctx.agentStatusNumber,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.agentStatusNumber = $event),
    placeholder: "切换座席状态",
    style: {
      "margin-right": "10px"
    },
    size: "mini",
    onChange: _ctx.updateAgentStatus
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agentStatusList, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.number,
        label: item.name,
        value: item.number
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.currentStatusName), 1), _createElementVNode("span", _hoisted_4, [_createVNode(_component_phoneBarTime, {
    ref: "phoneBarTimeRef"
  }, null, 512)]), _createVNode(_component_el_select, {
    modelValue: _ctx.loginType,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.loginType = $event),
    placeholder: "切换登陆方式",
    size: "mini",
    onChange: _ctx.updateLoginType
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loginTypeList, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_button, {
    class: "webphone-btn",
    type: "primary",
    disabled: !_ctx.isVisibleBtn('disconnect'),
    size: "mini",
    onClick: _ctx.disconnect
  }, {
    default: _withCtx(() => [_hoisted_5, _hoisted_6]),
    _: 1
  }, 8, ["disabled", "onClick"]), _createVNode(_component_el_button, {
    class: "webphone-btn",
    type: "primary",
    disabled: !_ctx.isVisibleBtn('connect'),
    size: "mini",
    onClick: _ctx.connect
  }, {
    default: _withCtx(() => [_hoisted_7, _hoisted_8]),
    _: 1
  }, 8, ["disabled", "onClick"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_input, {
    modelValue: _ctx.dialoutNumber,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.dialoutNumber = $event),
    style: {
      "width": "180px",
      "margin-right": "10px"
    },
    placeholder: "请输呼号码",
    onKeyup: _withKeys(_ctx.keyDowndialout, ["enter", "native"])
  }, null, 8, ["modelValue", "onKeyup"]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
    type: "primary",
    disabled: !_ctx.isVisibleBtn('dialout'),
    onClick: _ctx.dialout
  }, {
    default: _withCtx(() => [_hoisted_11, _hoisted_12]),
    _: 1
  }, 8, ["disabled", "onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    disabled: !_ctx.isVisibleBtn('hangup'),
    onClick: _ctx.hangup
  }, {
    default: _withCtx(() => [_hoisted_13, _hoisted_14]),
    _: 1
  }, 8, ["disabled", "onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    disabled: !_ctx.isVisibleBtn('hold'),
    onClick: _cache[3] || (_cache[3] = $event => _ctx.holdOrUnHold('1'))
  }, {
    default: _withCtx(() => [_hoisted_15, _hoisted_16]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_button, {
    type: "primary",
    disabled: !_ctx.isVisibleBtn('holdcancel'),
    onClick: _cache[4] || (_cache[4] = $event => _ctx.holdOrUnHold('2'))
  }, {
    default: _withCtx(() => [_hoisted_17, _hoisted_18]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_button, {
    type: "primary",
    disabled: !_ctx.isVisibleBtn('mute'),
    onClick: _cache[5] || (_cache[5] = $event => _ctx.muteOrUnMute('1'))
  }, {
    default: _withCtx(() => [_hoisted_19, _hoisted_20]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_button, {
    type: "primary",
    disabled: !_ctx.isVisibleBtn('mutecancel'),
    onClick: _cache[6] || (_cache[6] = $event => _ctx.muteOrUnMute('2'))
  }, {
    default: _withCtx(() => [_hoisted_21, _hoisted_22]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_button, {
    type: "primary",
    disabled: !_ctx.isVisibleBtn('answer'),
    onClick: _ctx.accept
  }, {
    default: _withCtx(() => [_hoisted_23, _hoisted_24]),
    _: 1
  }, 8, ["disabled", "onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: _ctx.getQueueOnlineAgents
  }, {
    default: _withCtx(() => [_hoisted_25, _hoisted_26]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: _ctx.agentOffline
  }, {
    default: _withCtx(() => [_hoisted_27, _hoisted_28]),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keyList, key => {
    return _openBlock(), _createBlock(_component_el_button, {
      key: key,
      type: "primary",
      disabled: !_ctx.isVisibleBtn('key'),
      onClick: $event => _ctx.sendDTMF(key)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(key), 1)]),
      _: 2
    }, 1032, ["disabled", "onClick"]);
  }), 128))])])]);
}